// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"526d58b6","457":"48e9776c","828":"aff844b1"}[chunkId] + ".chunk.js";
};